export const loadCookieYesScript = (cookieYesScriptId: string): void => {
    const scriptId = `cookieyes-${cookieYesScriptId}`;
    const isCookieYesScriptLoaded = document.getElementById(scriptId);

    if (!isCookieYesScriptLoaded) {
        const cookieYesScript = document.createElement("script");
        cookieYesScript.id = scriptId;
        cookieYesScript.type = "text/javascript";
        cookieYesScript.src = `https://cdn-cookieyes.com/client_data/${cookieYesScriptId}/script.js`;
        document.head.appendChild(cookieYesScript);
    }
};

export const loadLinkedInInsightTagScript = (): void => {
    const scriptId = "linkedin-insight-tag-pixel";
    const isLinkedInInsightTagScriptLoaded = document.getElementById(scriptId);

    const linkedInInsightTagId =
        process.env.REACT_APP_LINKED_IN_INSIGHT_TAG_ID ?? "";

    if (!isLinkedInInsightTagScriptLoaded) {
        const linkedInInsightTagScript = document.createElement("script");
        linkedInInsightTagScript.type = "text/javascript";
        linkedInInsightTagScript.innerHTML = `
            _linkedin_partner_id = "${linkedInInsightTagId}";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);

            (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);})(window.lintrk);
        `;
        linkedInInsightTagScript.id = scriptId;
        document.head.appendChild(linkedInInsightTagScript);
    }
};

export const loadUetTagScript = (): void => {
    const scriptId = "uet-tag-pixel";
    const isUetTagScriptLoaded = document.getElementById(scriptId);

    const uetTagId = process.env.REACT_APP_UET_TAG_ID ?? "";

    if (!isUetTagScriptLoaded) {
        const uetScript = document.createElement("script");
        uetScript.type = "text/javascript";
        uetScript.innerHTML = `
            (function(w, d, t, u, o) {
                w[u] = w[u] || [], o.ts = (new Date).getTime();
                var n = d.createElement(t);
                n.src = "https://bat.bing.net/bat.js?ti=" + o.ti + ("uetq" != u ? "&q=" + u : ""),
                n.async = 1, n.onload = n.onreadystatechange = function() {
                    var s = this.readyState;
                    s && "loaded" !== s && "complete" !== s ||
                    (o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad"),
                    n.onload = n.onreadystatechange = null)
                };
                var i = d.getElementsByTagName(t)[0];
                i.parentNode.insertBefore(n, i);
            })(window, document, "script", "uetq", {
                ti: "${uetTagId}",
                enableAutoSpaTracking: true
            });
        `;
        uetScript.id = scriptId;
        document.head.appendChild(uetScript);
    }
};

export const loadMetaPixelScript = (): void => {
    const scriptId = "meta-pixel";
    const isMetaPixelScriptLoaded = document.getElementById(scriptId);

    const metaPixelDataSetId =
        process.env.REACT_APP_META_PIXEL_DATASET_ID ?? "";

    if (!isMetaPixelScriptLoaded) {
        const metaScript = document.createElement("script");
        metaScript.type = "text/javascript";
        metaScript.innerHTML = `
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script',
    'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${metaPixelDataSetId}');
  fbq('track', 'PageView');
`;
        metaScript.id = scriptId;
        document.head.appendChild(metaScript);
    }
};

export const loadGoogleAnalyticsScript = (): void => {
    const gtagScriptId = "gtag";
    const gtagConfigScriptId = "gtag-config";
    const gtagConversionScriptId = "gtag-conversion";

    const isGtagScriptLoaded = document.getElementById(gtagScriptId);

    const googleAdsId = process.env.REACT_APP_GOOGLE_ADS_ID ?? "";

    if (!isGtagScriptLoaded) {
        const gtagScript = document.createElement("script");
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
        gtagScript.id = gtagScriptId;
        gtagScript.type = "text/javascript";
        document.head.appendChild(gtagScript);

        gtagScript.onload = () => {
            const configScript = document.createElement("script");
            configScript.type = "text/javascript";
            configScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', '${googleAdsId}');
  `;
            configScript.id = gtagConfigScriptId;
            document.head.appendChild(configScript);

            const conversionScript = document.createElement("script");
            conversionScript.type = "text/javascript";
            conversionScript.innerHTML = `
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof (url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': '${googleAdsId}/W6peCNOp0eUZEO2ulscC',
        'event_callback': callback
      });
      return false;
    }
  `;
            conversionScript.id = gtagConversionScriptId;
            document.head.appendChild(conversionScript);
        };
    }
};
